var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForkliftGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 51,
    viewBox: "0 0 45 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_93_16600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9276 6.78759C30.8379 3.69785 26.7282 2 22.3606 2C17.987 2 13.8833 3.69785 10.7936 6.78759C7.70385 9.87732 6 13.987 6 18.3546C6 27.1918 14.3573 34.5472 18.8509 38.4948C19.4748 39.0468 20.0088 39.5208 20.4408 39.9167C20.9807 40.4207 21.6706 40.6727 22.3606 40.6727C23.0505 40.6727 23.7405 40.4207 24.2744 39.9167C24.7064 39.5208 25.2463 39.0468 25.8703 38.4948C30.3579 34.5472 38.7152 27.1918 38.7152 18.3546C38.7152 13.987 37.0173 9.87732 33.9276 6.78759Z",
    fill: "#3D8B30",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 23.808C26.0649 23.808 25.8887 23.699 25.8109 23.5181L20.2907 10.6661C20.1867 10.4236 20.2985 10.1427 20.5408 10.0387C20.7835 9.93505 21.0642 10.0466 21.1682 10.2893L26.5004 22.7034L32.4889 20.1549C32.7323 20.0509 33.0123 20.1645 33.1156 20.4073C33.219 20.6503 33.1064 20.9307 32.8632 21.0336L26.4372 23.7686C26.3756 23.7948 26.3119 23.8078 26.25 23.8078V23.808ZM29.8895 14.499C29.7861 14.2562 29.5051 14.1434 29.2627 14.247L25.0289 16.0493C24.7858 16.153 24.6733 16.4336 24.7762 16.676L26.7469 21.3061C26.8505 21.5481 27.1307 21.6614 27.3736 21.5584L31.6078 19.7559C31.8506 19.6525 31.9639 19.3723 31.8602 19.1291L29.8895 14.499ZM20.3587 24.6709C20.3587 25.9894 21.4277 27.0587 22.7465 27.0587C24.065 27.0587 25.134 25.9892 25.134 24.6709C25.134 23.352 24.0651 22.2833 22.7465 22.2833C21.4277 22.2835 20.3587 23.352 20.3587 24.6709ZM19.7253 25.2283H16.3543C16.3543 23.8387 15.2276 22.7119 13.8376 22.7119C13.1115 22.7119 12.459 23.0212 12 23.5135V19.6482C12 19.3845 12.2137 19.1704 12.4778 19.1704H13.2411V13.8203C13.2411 13.4905 13.5083 13.2234 13.8381 13.2234H20.0958C20.3347 13.2234 20.5504 13.3657 20.6447 13.585L23.7374 20.8019C23.7759 20.8926 23.7884 20.9863 23.7817 21.079V21.0805V21.7791C23.4583 21.663 23.1108 21.5968 22.7474 21.5968C21.0496 21.5968 19.673 22.9729 19.673 24.6708C19.6722 24.8615 19.6919 25.0469 19.7252 25.2282L19.7253 25.2283ZM18.6927 20.6032H22.353L19.7016 14.4176H14.4342V19.1708H18.0188L18.6927 20.6032ZM12.007 25.2283C12.007 26.2393 12.8261 27.0588 13.8372 27.0588C14.8481 27.0588 15.6674 26.2397 15.6674 25.2283C15.6674 24.218 14.8483 23.3985 13.8372 23.3985C12.8261 23.3984 12.007 24.218 12.007 25.2283Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_93_16600",
    x: 0.5,
    y: 0.5,
    width: 43.7148,
    height: 49.6727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_16600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_16600",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForkliftGreenIcon);
export default __webpack_public_path__ + "static/media/ForkliftGreenIcon.0acd0d02b6e2b31cf48f1aa6494b97d8.svg";
export { ForwardRef as ReactComponent };